import { Toaster as SonnerToaster } from "sonner";

/**
 * Toaster component using Sonner
 * Styled to match Lumi's dark theme with accent colors
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-center"
      theme="dark"
      toastOptions={{
        style: {
          background: "#171717", // neutral-900
          color: "#ffffff",
          border: "1px solid #404040", // neutral-700
          borderRadius: "20px", // More rounded corners
          padding: "10px 16px", // More padding (top/bottom left/right)
          gap: "16px", // Space between icon and text
          fontSize: "14px",
          fontWeight: "500",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.5)", // Deeper shadow
        },
        classNames: {
          error: "!bg-red-900/50 !border-red-800 !text-red-100",
          success: "!bg-green-900/50 !border-green-800 !text-green-100",
          // You can also add custom classes for icon spacing
          icon: "!mr-0", // More space after icon
        },
      }}
      // Additional Sonner options:
      duration={4000} // How long toasts stay (ms)
      closeButton={false} // Show/hide close button
      richColors={true} // Better default colors for variants
      expand={false} // Don't expand on hover
    />
  );
}
